<template>
  <div class="module-activity">
    <div class="m-home-swiper">
      <div style="text-align:center">
        <!-- <img class="img-title" src="../../assets/images/home/pic_title5@2x.png" alt="" /> -->
      </div>

      <div class="swiper-box">
        <div class="swiper-container swiper-activity-container">
          <div class="swiper-wrapper">
            <router-link tag="div" :to="'/education/detail?id='+item.id" class="swiper-slide" v-for="(item, index) in dataList" @click="goDetail(item)" :key="index">
              <div class="pic-box">
                <img v-lazy="item.pictureUrl" alt="">
              </div>
              <div class="info">
                <h2 class="title pf-regular ell m-font-2">{{item.activityName}}</h2>
                <p class="tag pf-regular mt-20 mb-20">{{item.typeName}} ｜ {{item.activityAddr}}</p>
                <p class="time pf-regular mb-30">{{item.activityTime}}</p>
                <p class="desc pf-regular three-ell" v-html="item.description"></p>

                <div class="btn-sign m-font-6">查看详情</div>
                <!-- <div class="btn-sign m-font-6">立即报名</div> -->
              </div>
            </router-link>
          </div>
          <!-- <div class="swiper-button-prev swiper-button-white"></div>
          <div class="swiper-button-next swiper-button-black"></div>
          <div class="swiper-pagination swiper-pagination-activity"></div> -->
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    dataList: {
      handler() {
        this.initSwiper()
      },
      immediate: true
    }
  },

  data() {
    return {}
  },

  methods: {
    initSwiper() {
      this.$nextTick(() => {
        let swiper = new Swiper(".module-activity .swiper-container.swiper-activity-container", {
          // loop: true,
          // loopAdditionalSlides: 2,
          // autoplay: 5000,
          centeredSlides: true,
          slidesPerView: 1.4,
          // slidesPerView: 3,
          spaceBetween: 20,
          observer: true,
          observeParents: true,
          prevButton: '.module-activity .swiper-button-prev',
          nextButton: '.module-activity .swiper-button-next',
          pagination: '.module-activity .swiper-pagination-activity',
          paginationClickable: true,
          autoplayDisableOnInteraction: false, // 用户操作 swiper 之后自动切换不会停止
        })
      })
    },

    // getDataList() {
    //   this.listLoading = true
    //   this.$http
    //     .get('/public/index.do', {
    //       ...this.listQuery
    //     })
    //     .then(res => {
    //       this.listLoading = false
    //       if (res.success) {
    //         this.redList = res.data.Carousels
    //         this.initSwiper()
    //       } else {
    //         this.$message.error(res.message)
    //       }
    //     })
    // },

    goDetail(item) {
      // this.$router.push({
      //   path: '/sx-red/revolution/detail',
      //   query: { id: item.id }
      // })
    },

    getMore() {
      this.$router.push('/sx-red/revolution-list')
    }
  },
}
</script>

<style lang="scss" scoped>
.module-activity {
  margin-left: -120px;
  height: 750px;
  .swiper-box {
    width: 100%;
  }
  // .swiper-box {
  //   width: 1200px;
  //   margin: 0 auto;
  //   display: flex;
  //   position: relative;
  // }

  .swiper-wrapper {
    position: inherit;
  }

  .swiper-container {
    // padding-bottom: 30px;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }
  .swiper-slide {
    position: relative;
    // flex-basis: 386px;
    // flex-shrink: 0;
    // height: 500px;
    font-size: 18px;
    transition: 300ms;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    .pic-box {
      flex-shrink: 0;
      box-sizing: border-box;
      position: relative;
      height: 316px;
      // overflow: hidden;
      z-index: 1;
      // background: #ececec;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        // transition: all 0.6s;
      }
    }

    .info {
      width: 86%;
      top: -40px;
      left: 50%;
      transform: translateX(-50%);
      background: #fff;
      font-size: 26px;
      line-height: 39px;
      position: relative;
      z-index: 3;
      // background: url(../../assets/images/pic_frame@2x.png) no-repeat center;
      background-size: 100% 100%;
      padding: 40px 20px 150px 20px;
      box-sizing: border-box;
      border-left: solid 4px $primary;
      h2 {
        // font-size: 24px;
        line-height: 33px;
        // font-weight: bold;
        color: #333333;
        // &:hover {
        //   text-decoration: underline;
        // }
      }
      .tag {
        color: rgba($color: #303030, $alpha: 0.7);
        font-size: 28px;
      }
      .time {
        font-size: 28px;
      }

      .btn-sign {
        position: absolute;
        right: 20px;
        bottom: 20px;
        // font-size: 16px;
        width: 105px;
        height: 105px;
        line-height: 105px;
        text-align: center;
        border-radius: 100%;
        color: #fff;
        background: $primary;
      }
    }

    &:hover {
      // .pic-box {
      //   img{
      //     transform: scale(1.02);
      //   }
      // }
      .info {
        border-left-color: #608267;
        h2 {
          color: #608267;
        }
        .btn-sign {
          background: #608267;
        }
      }
    }
  }

  .swiper-button-next, 
  .swiper-button-prev {
    width: 24px !important;
    height: 24px !important;
    // top: 480px;
    top: initial !important;
    bottom: 0 !important;
    // z-index: 9;
  }
  .swiper-button-prev {
    left: 45% !important;
  }
  .swiper-button-next {
    right: 45% !important;
  }

  /deep/ .swiper-pagination {
    width: 100px;
    left: 50%;
    bottom: 5px;
    transform: translateX(-50%);
    // left: 170px;
  }
}
</style>